module.exports = __webpack_public_path__ + "img/showcase-img2.b8511696.png";